// extracted by mini-css-extract-plugin
export default {"siteTitleSlogan":"LandTitleStyle_siteTitleSlogan__8zbfC","siteTitleSlogan__inputBlock":"LandTitleStyle_siteTitleSlogan__inputBlock__u0u29"};